export default __webpack_public_path__ + "ec5a51ab465f6965f66d8d5542cdec75.png";